import React, { useEffect, useState } from "react";
import { DashboardFilter, StackedBar } from "../../components";
import { getDashboardPerWasteType, getDepartmentsByLocationId } from "../../services";

const PerWasteType = (props) => {
  const { startDate, endDate, filter, locationId } = props;
  const [data, setData] = useState();
  const [departments, setDepartments] = useState();

  useEffect(() => {
    getDepartmentsByLocationId(locationId).then((res) => {
      setDepartments(res.departments);
    });
  }, []);

  useEffect(() => {
    getDashboardPerWasteType(locationId, startDate, endDate, filter).then(
      (res) => {
        setData(res);
      }
    );
  }, [startDate, endDate, filter]);

  // Only render dashboard if data is populated
  if (data) {
    // Create departmentlist for values in x-axis
    const departmentLookupList = {};
    const departmentIdList = [];

    if(departments) {
      departments.forEach((dep, value) => {
        departmentIdList.push(dep.id);
        departmentLookupList[dep.id] = dep.name;
      });
    }

    let format = (v) => `${parseFloat(v/1000).toFixed(2)} kg`
    if (filter == 1) format = (v) => `€${parseFloat(v).toFixed(2)}`

    return (
      <StackedBar
        data={data.data}
        ticks={departmentIdList}
        lookup={departmentLookupList}
        format={format}
      />
    );
  } else {
    return <div></div>;
  }
};

export default PerWasteType;
